export function isLegacyOSMClientId(clientId: string) {
  return clientId.replace(/-/g, '').length <= 32
}
